import { render } from "./HzbaList.vue?vue&type=template&id=48d21770&scoped=true&ts=true"
import script from "./HzbaList.vue?vue&type=script&lang=ts"
export * from "./HzbaList.vue?vue&type=script&lang=ts"

import "./HzbaList.vue?vue&type=style&index=0&id=48d21770&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d21770"]])

export default __exports__